import React from 'react';
import { useTranslation } from '@lt/localization';
import styled from 'styled-components';
import LinkPopup from 'src/components/Popup/LinkPopup';

const HotelAgreement = ({ isWhitelabel, isMobile, isHotelOnly }) => {
  const { t } = useTranslation();
  const agreementLink = `/articles/${
    isWhitelabel ? 'partner_license_agreement' : 'license_agreement'
  }`;
  const width = isMobile ? '90vw' : '800px';

  return (
    <StyledAgreement isHotelOnly={isHotelOnly}>
      {t('checkout.agreement.title')}
      <LinkPopup href="/articles/agreement" width={width}>
        {t('checkout.agreement.document')},{' '}
      </LinkPopup>
      <LinkPopup href={agreementLink} width={width}>
        {t('checkout.agreement.client')},{' '}
      </LinkPopup>
      <LinkPopup href="/articles/order_information" width={width}>
        {t('checkout.agreement.order')}
      </LinkPopup>
      {t('checkout.agreement.textHotel')}
    </StyledAgreement>
  );
};

const StyledAgreement = styled.div<{ isHotelOnly: boolean }>`
  color: #4d4d4d;
  font-size: 14px;
  width: 350px;
  ${({ isHotelOnly }) => !isHotelOnly && 'margin-left: 22px;'}
`;

export default HotelAgreement;
